module.exports = __webpack_public_path__ + "img/room_3.64cce4a8.png";